import { render, staticRenderFns } from "./PrintSmallOrder.vue?vue&type=template&id=32a3c1c1&scoped=true"
import script from "./PrintSmallOrder.vue?vue&type=script&lang=js"
export * from "./PrintSmallOrder.vue?vue&type=script&lang=js"
import style0 from "./PrintSmallOrder.vue?vue&type=style&index=0&id=32a3c1c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3c1c1",
  null
  
)

export default component.exports